import React from "react";

import { Grid } from "@mui/material";

import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { formatAwsDateString } from "@covertree/utils";

import { RenewalDetailsContentProps } from "@routing/routes/Renewals/RenewalDetails/RenewalDetailsContent/ContentTabs/types";

export function DiscardDetails({ renewal }: RenewalDetailsContentProps) {
  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Discarded Date",
            value: renewal?.discardedDate
              ? formatAwsDateString(renewal.discardedDate)
              : "N/A",
            gridSize: 6,
          },
          {
            label: "Discarded By",
            value: renewal?.discardedBy || "N/A",
            gridSize: 6,
          },
        ]}
      />
    </Grid>
  );
}
